import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './containers/App/App';
import * as serviceWorkerRegistration from './pwa/serviceWorkerRegistration';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

serviceWorkerRegistration.register();
